import { ButtonContainer, Divider, EduStyledButton, List, ListItem, Number, StyledTertiaryButton } from '../../styles';

interface DefaultNoRxProps {
  onContinueToRxPage: () => void;
  onSkipForNowClick: () => void;
}

const DefaultNoRx = ({ onContinueToRxPage, onSkipForNowClick }: DefaultNoRxProps) => {
  return (
    <>
      <List hasMarginTop={true}>
        <ListItem hasMarginBottom={true}>
          <Number>1.</Number>
          If you have a prescription at another pharmacy, we can deliver your next fill.
        </ListItem>
        <ListItem>
          <Number>2.</Number>
          When your doctor asks, "What's your pharmacy?" say, "Capsule." We are already in their medical system and will
          text you to schedule delivery.
        </ListItem>
      </List>
      <Divider />
      <ButtonContainer>
        <EduStyledButton onClick={onContinueToRxPage} type="submit" style={'capsuleBlue50'} size="medium">
          Fill my prescription
        </EduStyledButton>
        <StyledTertiaryButton style="tertiary" size="medium" onClick={onSkipForNowClick}>
          Skip for now
        </StyledTertiaryButton>
      </ButtonContainer>
    </>
  );
};

interface NoRxProps {
  onContinueToRxPage: () => void;
  onSkipForNowClick: () => void;
}

export const NoRx = ({ onContinueToRxPage, onSkipForNowClick }: NoRxProps) => {
  return <DefaultNoRx onContinueToRxPage={onContinueToRxPage} onSkipForNowClick={onSkipForNowClick} />;
};
